import React from 'react';
import Header from './components/Header';
// import Logos from "components/Elements/LogosList";
import Logos from './components/Logos';
import SwiperContainer from './components/SwiperContainer';
import VideoBG from '@/assets/videos/bg_gas.mp4';

import '@/styles/sections/pages/Home/testimonials.scss';

const Testimonials = ({ data }) => {
  return (
    <section className={'cr-home-testimonials-sec'}>
      <div className="cr-wrap">
        <div className={'cr-home-testimonials'}>
          <Header title={data.title} subtitle={data.subtitle} />
          {/* TODO: использовать общий компонент */}
          <Logos logos={data.logos} />
          <SwiperContainer testimonials={data.slides} />
        </div>
      </div>
      <video src={VideoBG} autoPlay="autoplay" loop="loop"></video>
    </section>
  );
};

export default Testimonials;
